<template>
    <li class="categories-list__item">
        <!-- <a :href="category.url"> -->
        <router-link :to="toCategoryLink()">
            <div class="image image--type--category">
                <div class="image__body">
                <img
                    class="image__tag"
                    :src="image_src"
                    :alt="category.categoryname"
                />
                </div>
            </div>
            <div class="categories-list__item-name">
                {{category.categoryname}}
            </div>
        <!-- </a> -->
        </router-link>
        <!-- <div class="categories-list__item-products">28 Products</div> -->
    </li>
    <li class="categories-list__divider"></li>
</template>

<script>
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';
import axios from 'axios';
import SolrHelper from '../../../mixins/solr_helper';
import Cloudinary from '../../../utilities/cloudinary';
import {scale} from "@cloudinary/base/actions/resize";

export default {
    props : {
        category: {
            type : Object
        }
    },
    mixins: [ SolrHelper ],
    data() {
        return {
            image_src: GCONST.THUMB_IMAGE_PLACEHOLDER,
            level: 1,
        };
    },

    methods: {
        toCategoryLink() {
            const st_categories = this.$store.getters['product/categories'];
            const level = this.category.categorylevel;
            const childlvl = level + 1;

            const child_cats = st_categories.filter((cat) => {
                switch (level){
                    case 2:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02) && (cat.categorylevel === childlvl));
                    case 3:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.categorylevel === childlvl));
                    case 4:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.categorylevel === childlvl));
                    case 5:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.categorylevel === childlvl));
                    case 6:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.categorylevel === childlvl));
                    case 7:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.DMCD07 === this.category.DMCD07) && (cat.categorylevel === childlvl));
                    case 8:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.DMCD07 === this.category.DMCD07) && (cat.DMCD08 === this.category.DMCD08) && (cat.categorylevel === childlvl));
                    case 9:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.DMCD07 === this.category.DMCD07) && (cat.DMCD08 === this.category.DMCD08) && (cat.DMCD09 === this.category.DMCD09) && (cat.categorylevel === childlvl));
                    case 10:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.DMCD07 === this.category.DMCD07) && (cat.DMCD08 === this.category.DMCD08) && (cat.DMCD09 === this.category.DMCD09)  && (cat.DMCD10 === this.category.DMCD10) && (cat.categorylevel === childlvl));
                }
            });

            // console.log(this.category);
            // console.log(child_cats);
            let params = '';
            let l = 1;
            if ((child_cats.length > 0) && (level < 10)){
                params = '/category/'+level;
                while (l <= level){
                    if(l < 10){
                        params += '/' + this.category['DMCD0' + l];
                    }else{
                        params += '/' + this.category['DMCD10'];
                    }
                    l++;
                }
            }else{
                params = '/sub-category/'+level;
                while (l <= level){
                    if(l < 10){
                        params += '/' + this.category['DMCD0' + l];
                    }else{
                        params += '/' + this.category['DMCD10'];
                    }
                    l++;
                }
            }

            let ln = 1;
            while (ln <= level){
                const curr_cat = this.fetchCatDetails(ln);
                // console.log(curr_cat);
                params += '/' + curr_cat[0].categoryname.replace(/ /g, '-');
                ln++;
            }

            return params;
        },

        fetchCatDetails(level) {
            const st_categories = this.$store.getters['product/categories'];
            // const level = this.category.categorylevel;

            const cat = st_categories.filter((cat) => {
                switch (level){
                    case 1:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.categorylevel === level));
                    case 2:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02) && (cat.categorylevel === level));
                    case 3:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.categorylevel === level));
                    case 4:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.categorylevel === level));
                    case 5:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.categorylevel === level));
                    case 6:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.categorylevel === level));
                    case 7:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.DMCD07 === this.category.DMCD07) && (cat.categorylevel === level));
                    case 8:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.DMCD07 === this.category.DMCD07) && (cat.DMCD08 === this.category.DMCD08) && (cat.categorylevel === level));
                    case 9:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.DMCD07 === this.category.DMCD07) && (cat.DMCD08 === this.category.DMCD08) && (cat.DMCD09 === this.category.DMCD09) && (cat.categorylevel === level));
                    case 10:
                        return ((cat.DMCD01 === this.category.DMCD01) && (cat.DMCD02 === this.category.DMCD02)  && (cat.DMCD03 === this.category.DMCD03) && (cat.DMCD04 === this.category.DMCD04) && (cat.DMCD05 === this.category.DMCD05) && (cat.DMCD06 === this.category.DMCD06) && (cat.DMCD07 === this.category.DMCD07) && (cat.DMCD08 === this.category.DMCD08) && (cat.DMCD09 === this.category.DMCD09)  && (cat.DMCD10 === this.category.DMCD10) && (cat.categorylevel === level));
                }
            });

            return cat;
        },

        category_image() {
            const clApi = new CloudinaryApi;
            clApi.category_id = this.category.DMCD01;
            clApi.category_2 = this.category.DMCD02;
            clApi.category_3 = this.category.DMCD03;
            clApi.category_4 = this.category.DMCD04;
            clApi.category_5 = this.category.DMCD05;
            clApi.category_6 = this.category.DMCD06;
            clApi.category_7 = this.category.DMCD07;
            clApi.category_8 = this.category.DMCD08;
            clApi.category_9 = this.category.DMCD09;
            clApi.category_10 = this.category.DMCD10;
            
            clApi.vlImageByMeta(GCONST.CL_META_CATEGORY_ID, GCONST.Category).then(imgURL => {
                if(imgURL){
                    this.image_src = imgURL;
                }else{
                    this.category_product();
                }
            });
        },

        async category_product() {
            const rows = 1;
            const start = 0;
            // const custom_attr = this.$store.getters['product/custom_attrs'];
            const catCode = this.$route.params.categoryUri1;
            
            this.$emit('clear_messages');
            this.parts = [];
            this.more_filters = [];
            this.isloading = true;

            let filter_uri = '';

            this.level = this.$route.params.level;
            let lvl = 1;
            while(lvl <= this.level){
                filter_uri += '&fq=DMCD0'+lvl+':' + this.$route.params['categoryUri' + lvl];
                lvl += 1;
            }

            if(lvl == 10){
                filter_uri += '&fq=DMCD'+lvl+':' + this.category['DMCD' + lvl] + '&fq=Image:[* TO *]';
            }else{
                filter_uri += '&fq=DMCD0'+lvl+':' + this.category['DMCD0' + lvl] + '&fq=Image:[* TO *]';
            }

            filter_uri += this.mx_get_filter();

            // const uri = 'http://localhost:8983/solr/dms_products/select?facet.field=Color&facet=true&indent=true&q.op=OR&q=Item%3A*'+this.keyword+'*';
            const solr_host = this.$store.getters.solr_hostname + '/solr/' + this.$store.getters.solr_coreadmin;
            let uri = solr_host + '/select?q.op=AND&q=DMCD01%3A'+catCode+'&facet.field=IGDESC&facet.field=MCNAME&facet=true&f.B2C_price.facet.range.start=0&f.B2C_price.facet.range.end=1000&f.B2C_price.facet.range.gap=100&facet.range=B2C_price&f.Weight.facet.range.start=0&f.Weight.facet.range.end=100&f.Weight.facet.range.gap=10&facet.range=Weight&group=true&group.field=Item&group.facet=true&group.format=simple&group.ngroups=true&sort=Image desc';
            let paginate_uri = '&rows=' + rows+ '&start=' + start;
            // const sorting_uri = '&sort=Stocks%20desc,%20Stocking_Flag%20desc';

            uri += filter_uri  + paginate_uri;
            // + this.facet_field_uri
            await axios.get(uri,{
                auth: {
                    username: this.$store.getters.solr_username,
                    password: this.$store.getters.solr_password
                }
            })
            .then((response) => {
                const parts = response.data.grouped.Item.doclist.docs;
                if(parts.length > 0){
                    if(parts[0].Image != '') {
                        this.image_src = parts[0].Image;
                    }else{
                        this.defaultImage();
                    }
                }else{
                    this.defaultImage();
                }

                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        defaultImage() {
            const cat1_images = this.$store.getters.cat_img_level_1.find(img => (img.DXCD01 == this.category.DMCD01));
            if(cat1_images != undefined){
                const clImage = Cloudinary.image(cat1_images.publicId);
                clImage.resize(scale().width(GCONST.Category));
                this.image_src = clImage.toURL();
            }else{
                this.image_src = GCONST.IMAGE_PLACEHOLDER;
            }
        }
    },

    created() {
        this.category_image();
    },

    updated() {
        this.category_image();
    }
}
</script>